// extracted by mini-css-extract-plugin
module.exports = {"container":"HotKey_container__WmPBz","key":"HotKey_key__TwJJb"};